<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 56 54"
    style="enable-background:new 0 0 56 54;"
    xml:space="preserve"
  >
    <g id="Layer_1">
      <g id="Layer_2_1_">
        <g id="DC_EC_Logo_Surface">
          <g id="Outline_no_shadow">
            <path
              class="svg-secondary"
              d="M9.9,0h36.2C51.6,0,56,4.4,56,9.9v34.2c0,5.5-4.4,9.9-9.9,9.9H9.9C4.4,54,0,49.6,0,44.1V9.9      C0,4.4,4.4,0,9.9,0z"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="Layer_2">
      <g id="Layer_86">
        <path
          id="_64"
          class="svg-bg"
          d="M45,31.2c-2.6-2.7-9.7-1.6-11.4-1.4c-2.5-2.4-4.2-5.3-4.8-6.3c0.9-2.7,1.5-5.4,1.6-8.3    c0-2.5-1-5.2-3.8-5.2c-1,0-1.9,0.6-2.4,1.4c-1.2,2.1-0.7,6.3,1.2,10.6c-1.1,3.1-2.1,6.1-4.9,11.4c-2.9,1.2-9,4-9.5,7    c-0.2,0.9,0.1,1.8,0.8,2.5c0.7,0.6,1.6,0.9,2.5,0.9c3.7,0,7.3-5.1,9.8-9.4c2.1-0.7,5.4-1.7,8.7-2.3c3.9,3.4,7.3,3.9,9.1,3.9    c2.4,0,3.3-1,3.6-1.9C46,33.1,45.7,32,45,31.2z M42.5,32.9c-0.1,0.7-1,1.4-2.6,1c-1.9-0.5-3.6-1.4-5.1-2.6    c1.3-0.2,4.2-0.5,6.3-0.1C41.9,31.4,42.7,31.9,42.5,32.9z M25.8,12.3c0.2-0.3,0.5-0.5,0.8-0.5c0.9,0,1.1,1.1,1.1,2    c-0.1,2.1-0.5,4.2-1.2,6.2C25,16,25.3,13.2,25.8,12.3z M25.6,31.7c0.8-1.6,1.9-4.4,2.3-5.6c0.9,1.5,2.4,3.3,3.2,4.1    C31.1,30.3,28,30.9,25.6,31.7z M19.7,35.7c-2.3,3.8-4.7,6.2-6,6.2c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.2-0.4-0.5-0.3-0.9    C13.1,39.4,15.7,37.5,19.7,35.7z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "SvgIconPdf",
  }
</script>
